import React from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import Control from '../form/Control';
import Loading from '../loading/Loading';
var NewCard = function(props) {
    var name = props.name, value = props.value, label = props.label, error = props.error, isFailed = props.isFailed, onChange = props.onChange, onPaymentElementChange = props.onPaymentElementChange;
    var stripe = useStripe();
    var elements = useElements();
    var isLoading = !stripe || !elements;
    return isLoading ? /*#__PURE__*/ React.createElement(Loading, null) : /*#__PURE__*/ React.createElement("div", {
        className: "NewCard"
    }, /*#__PURE__*/ React.createElement(Control, {
        onChange: onChange,
        label: label,
        as: "input",
        type: "text",
        name: name,
        value: value,
        isFailed: isFailed,
        validationError: error
    }), /*#__PURE__*/ React.createElement(PaymentElement, {
        onChange: function(elementProps) {
            return onPaymentElementChange(elementProps.complete);
        },
        options: {
            fields: {
                billingDetails: {
                    address: {
                        country: 'never'
                    }
                }
            }
        }
    }));
};
export default NewCard;
